import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { COLORS } from "../config/theme/baseTheme";
import { useColorStyles } from "SharedComponent/styles/Colores.styles";
import {
  geocodedAddressStyles,
  deliveryProofSectionStyles,
  modalStyles,
  useSideModalCloseOpenStyles,
  headingContainerStyles,
  tabularSectionCratesStyles,
  tabularSectionItemContentStyles,
  tagStyles,
  timelineStyles,
} from "SharedComponent/styles/sharedStyles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    titleContainer: {
      ...headingContainerStyles(),
      "& .tagContainer": {
        marginLeft: theme.spacing(1),
        "& .tag": {
          ...tagStyles(theme).base,
          ...useColorStyles(theme),
        },
      },
      "& .editIcon": {
        paddingLeft: theme.spacing(1.5),
        "& .icon": {
          cursor: "pointer",
          verticalAlign: "middle",
        },
      },
    },
    contentContainer: {
      flexDirection: "column",
      flexWrap: "nowrap",
      "& .geocodedAddress": {
        paddingBottom: theme.spacing(2),
        ...geocodedAddressStyles(theme),
      },
      "& .collectionsHeader": {
        backgroundColor: COLORS.TRANSPARENT_BLUE,
        padding: theme.spacing(2),
        borderRadius: theme.spacing(1),
        marginTop: "8px",
        display: "flex",
        "& .detailsHeaderItem": {
          paddingBottom: theme.spacing(1),
          "&:last-child": {
            paddingBottom: 0,
          },
          "& .headerItemContainer": {
            alignItems: "center",
            flexWrap: "nowrap",
          },
          "& p": {
            lineHeight: "17px",
            fontSize: 14,
          },
          "& .name": {
            marginTop: "8px",
            fontWeight: 600,
          },
        },
      },
      "& .detailsHeader": {
        flexDirection: "column",
        backgroundColor: COLORS.TRANSPARENT_BLUE,
        padding: theme.spacing(2),
        borderRadius: theme.spacing(1),
        "& .detailsHeaderItem": {
          paddingBottom: theme.spacing(1),
          "&:last-child": {
            paddingBottom: 0,
          },
          "& .headerItemContainer": {
            alignItems: "center",
            flexWrap: "nowrap",
          },
          "& .contactItemContainer": {
            alignItems: "center",
            flexWrap: "nowrap",
          },
          "& p": {
            lineHeight: "17px",
            fontSize: 14,
          },
          "& .name": {
            fontWeight: 600,
          },
          "&.geocodedAddress": {
            paddingBottom: theme.spacing(2),
            ...geocodedAddressStyles(theme),
          },
          "& .contactMobile": {
            marginRight: theme.spacing(5),
          },
          "& .logo": {
            width: 24,
            height: 24,
          },
          "& .contact": {
            "& a": {
              lineHeight: "17px",
              fontSize: 14,
              fontWeight: 600,
              textDecoration: "none",
              color: theme.palette.text.primary,
            },
            paddingLeft: theme.spacing(1),
            "&.mobile": {
              paddingLeft: theme.spacing(0.25),
            },
          },
        },
      },
      "& .detailsContent": {
        flexDirection: "column",
        flexWrap: "nowrap",
        padding: theme.spacing(3),
        "& .contentRow": {
          paddingBottom: theme.spacing(3),
          "&.rowContainer": {
            display: "flex",
            justifyContent: "space-between",
          },
          "&.hubDetails": {
            paddingBottom: theme.spacing(1),
          },
          "&:last-child": {
            paddingBottom: 0,
          },
          "& .contentColumn": {
            "& p": {
              fontSize: 14,
              lineHeight: "17px",
            },
            "& .label": {
              paddingBottom: theme.spacing(1),
            },
            "& .content": {
              fontWeight: 600,
            },
          },
        },
      },
      "& .sellerDetails": {
        paddingTop: theme.spacing(1.75),
        "& .detailsHeader": {
          backgroundColor: theme.palette.secondary.main,
        },
      },
      ...deliveryProofSectionStyles(theme),
      "& .consignmentHistory": {
        paddingBottom: theme.spacing(1.5),
      },
      "& .tabularSection": {
        paddingBottom: theme.spacing(1),
        "&:last-child": {
          paddingBottom: 0,
        },
        "&.crates": {
          ...tabularSectionCratesStyles(theme),
        },
        "& .itemDiv": {
          padding: theme.spacing(0),
          "& .content": {
            ...tabularSectionItemContentStyles(theme),
          },
        },
      },
    },
    accordionSummary: {
      "& .header": {
        fontSize: 14,
        fontWeight: 600,
        paddingBottom: theme.spacing(0.5),
        "&:last-child": {
          paddingBottom: 0,
        },
        "& .smallHeading": {
          fontSize: 12,
        },
      },
      "& .content": {
        flexGrow: 1,
      },
    },
    ...timelineStyles(theme),
    dialogPaperPropsRoot: {
      ...modalStyles().dialogPaper,
    },
    verticalDiv: {
      color: "#0E5AA7",
      height: "16px",
      background: "#0E5AA7",
      width: "2px",
      margin: "2px 16px 0px 16px",
    },
    ...useSideModalCloseOpenStyles(),
  })
);
